var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c("div", { staticClass: "single container-max page-content" }, [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 col-lg-7 mt-5 mb-3 mb-md-5" },
                  [
                    _vm._t("image-carousel"),
                    _vm._v(" "),
                    _vm.hasProp377Socks
                      ? _c(
                          "div",
                          {
                            staticClass: "free-socks d-none d-md-flex p-2 mt-3"
                          },
                          [_vm._t("free-socks")],
                          2
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-6 col-lg-4 mt-md-5 buybox mb-md-5"
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "h2 title",
                            attrs: { "data-testing": "item-name" }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("itemName")(_vm.currentVariation)
                                  ) +
                                  "\n              "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.hasValue18 ||
                        _vm.hasValue19 ||
                        _vm.hasValue19 ||
                        _vm.hasValue20 ||
                        _vm.hasValue21 ||
                        _vm.hasValue22 ||
                        _vm.hasValue23 ||
                        _vm.hasValue24 ||
                        _vm.hasValue25
                          ? _c("hr")
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "list-unstyled d-flex socks flex-wrap"
                          },
                          [
                            _vm.hasValue18
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon18"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text18"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text18"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue19
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon19"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text19"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text19"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue20
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon20"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text20"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text20"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue21
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon21"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text21"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text21"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue22
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon22"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text22"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text22"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue23
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon23"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text23"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text23"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue24
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon24"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text24"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text24"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasValue25
                              ? _c(
                                  "li",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("img", {
                                      staticClass: "sockenicons mx-auto",
                                      attrs: {
                                        src: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Icon25"
                                        ),
                                        alt: _vm.$translate(
                                          "sockenrauschVueTheme::SingleItemSockenIcons.Text25"
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "mb-0 text-center",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemSockenIcons.Text25"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-none" },
                          [_vm._t("tag-list")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.attributes.length || Object.keys(_vm.units).length
                          ? _c(
                              "div",
                              { staticClass: "mb-3" },
                              [_c("variation-select")],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("before-price"),
                        _vm._v(" "),
                        _vm.currentVariation.filter.isSalable &&
                        _vm.variationGroupedProperties.length
                          ? _c("div", [_c("order-property-list")], 1)
                          : _vm._e(),
                        _vm._v(" "),
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("after-price"),
                        _vm._v(" "),
                        _vm._t("additional-content-after-vat"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "fs-availability" },
                          [_c("item-availability")],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasProp377Socks
                          ? _c(
                              "div",
                              {
                                staticClass: "free-socks d-flex d-md-none p-2"
                              },
                              [_vm._t("free-socks")],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt-3 mb-4 fs-addtobasket" }, [
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            [_vm._t("before-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm.currentVariation.item.itemType === "set"
                            ? _c(
                                "div",
                                { staticClass: "alert alert-info w-100" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemSetInfo"
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-sm-7 col-md-12 my-3 px-0"
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100 ppbtn" },
                            [_vm._t("after-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "list-unstyled d-flex flex-wrap mt-4"
                            },
                            [
                              _vm.$translate(
                                "sockenrauschVueTheme::SingleItemUSPs.USP1ImgUrl"
                              ) != ""
                                ? _c("li", { staticClass: "w-100 mb-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemUSPs.USP1LinkTo"
                                          )
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid mr-3",
                                          attrs: {
                                            src: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP1ImgUrl"
                                            ),
                                            alt: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP1Headline"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "sockenrauschVueTheme::SingleItemUSPs.USP1Headline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$translate(
                                "sockenrauschVueTheme::SingleItemUSPs.USP2ImgUrl"
                              ) != ""
                                ? _c("li", { staticClass: "w-100 mb-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemUSPs.USP2LinkTo"
                                          )
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid mr-3",
                                          attrs: {
                                            src: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP2ImgUrl"
                                            ),
                                            alt: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP2Headline"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "sockenrauschVueTheme::SingleItemUSPs.USP2Headline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$translate(
                                "sockenrauschVueTheme::SingleItemUSPs.USP3ImgUrl"
                              ) != ""
                                ? _c("li", { staticClass: "w-100 mb-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemUSPs.USP3LinkTo"
                                          )
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid mr-3",
                                          attrs: {
                                            src: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP3ImgUrl"
                                            ),
                                            alt: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP3Headline"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "sockenrauschVueTheme::SingleItemUSPs.USP3Headline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$translate(
                                "sockenrauschVueTheme::SingleItemUSPs.USP4ImgUrl"
                              ) != ""
                                ? _c("li", { staticClass: "w-100 mb-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemUSPs.USP4LinkTo"
                                          )
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid mr-3",
                                          attrs: {
                                            src: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP4ImgUrl"
                                            ),
                                            alt: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP4Headline"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "sockenrauschVueTheme::SingleItemUSPs.USP4Headline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$translate(
                                "sockenrauschVueTheme::SingleItemUSPs.USP5ImgUrl"
                              ) != ""
                                ? _c("li", { staticClass: "w-100 mb-3" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        attrs: {
                                          href: _vm.$translate(
                                            "sockenrauschVueTheme::SingleItemUSPs.USP5LinkTo"
                                          )
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid mr-3",
                                          attrs: {
                                            src: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP5ImgUrl"
                                            ),
                                            alt: _vm.$translate(
                                              "sockenrauschVueTheme::SingleItemUSPs.USP5Headline"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "sockenrauschVueTheme::SingleItemUSPs.USP5Headline"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._t("additional-content-after-add-to-basket")
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c("p", { staticClass: "h3" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "sockenrauschVueTheme::SingleItem.DescriptionHeadline"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "my-4",
                    domProps: {
                      innerHTML: _vm._s(_vm.currentVariation.texts.description)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "eu-responsible small" }, [
                    _c("p", { staticClass: "h4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemEuResponsiblePerson"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleStreet
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleHouseNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePostCode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleTown
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer
                        .responsibleCountryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .responsibleCountryObject.name
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleEmail
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsiblePhoneNo
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer
                              .responsibleContactUrl
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "eu-responsible small mt-4" }, [
                    _c("p", { staticClass: "h4" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Ceres::Template.singleItemManufacturer"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.name)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.legalName
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.street)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.houseNo)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.postcode
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.town)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.currentVariation.item.manufacturer.countryObject
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.currentVariation.item.manufacturer
                                    .countryObject.name
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.email)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.currentVariation.item.manufacturer.url)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.phoneNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.faxNumber
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "p-0" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.currentVariation.item.manufacturer.contactUrl
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "item-data-container mb-5 mb-md-0" },
                    [
                      _c("p", { staticClass: "h3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "sockenrauschVueTheme::SingleItem.TechnicalDataHeadline"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-data" }, [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.currentVariation.texts.technicalData
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3 text-center" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "d-inline-block text-muted text-center p-2 btn-more",
                            attrs: {
                              href: "#",
                              onclick:
                                "event.preventDefault(); document.getElementsByClassName('item-data-container')[0].classList.toggle('show');"
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "font-weight-bold show-more" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "sockenrauschVueTheme::SingleItem.ShowMore"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold show-less" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "sockenrauschVueTheme::SingleItem.ShowLess"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "single container-max page-content" }, [
              _c(
                "div",
                { staticClass: "row cross-selling" },
                [
                  _vm._t("cross-selling-accessory"),
                  _vm._v(" "),
                  _vm._t("cross-selling-similar"),
                  _vm._v(" "),
                  _vm._t("feedback-container")
                ],
                2
              )
            ])
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }